(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stk-dtc-subscription-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stk-dtc-subscription')) {
    customElements.define('stk-dtc-subscription', class extends HTMLElement {
      connectedCallback() {
        this.onReady = () => this.initialize();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, {once: true});
        else this.initialize();
      }
      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.initialized = true;
        this.form = this.closest('form');
        this.select = this.querySelector('[data-frequency]');
        this.once = this.querySelector('input[value="once"]');
        this.subscribe = this.querySelector('input[value="subscribe"]');
        this.input = this.querySelector('[data-selling-plan]');
        this.variantSelection = this.form.querySelector('[data-variant-selection]');
        this.onVariant = event => this.switchVariant(event.detail.variant?.id ?? event.detail.state);
        this.onChange = () => this.update();
        this.once.checked = true;
        this.subscribe.checked = false;
        this.addEventListener('change', this.onChange);
        this.variantSelection?.addEventListener('variant-change', this.onVariant);
        this.switchVariant(this.dataset.initialVariant);
        // Browser back/forward restoration must not silently enroll a one-time buyer.
        this.onPageShow = () => { this.once.checked = true; this.subscribe.checked = false; this.update(); };
        window.addEventListener('pageshow', this.onPageShow);
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.onReady);
        this.removeEventListener('change', this.onChange);
        this.variantSelection?.removeEventListener('variant-change', this.onVariant);
        window.removeEventListener('pageshow', this.onPageShow);
        this.initialized = false;
      }
      switchVariant(id) {
        const source = Array.from(this.querySelectorAll('template[data-variant]')).find(item => item.dataset.variant === String(id));
        const previous = this.select.value;
        this.select.replaceChildren(...Array.from(source?.content.querySelectorAll('option') || [], option => option.cloneNode(true)));
        if (Array.from(this.select.options).some(option => option.value === previous)) this.select.value = previous;
        this.hidden = !this.select.options.length;
        if (this.hidden) { this.once.checked = true; this.subscribe.checked = false; }
        this.querySelector('[data-once-price]').textContent = source?.dataset.oncePrice || '';
        this.update();
      }
      update() {
        const plan = this.select.selectedOptions[0];
        const subscribed = this.subscribe.checked && Boolean(plan) && !this.hidden;
        this.input.disabled = !subscribed;
        this.input.value = subscribed ? plan.value : '';
        this.querySelector('[data-schedule]').hidden = !subscribed;
        this.querySelector('[data-sub-price]').textContent = plan?.dataset.price || '';
        this.querySelector('[data-summary]').textContent = subscribed
          ? this.dataset.recurringSummary.replace('__PRICE__', plan.dataset.price).replace('__CADENCE__', plan.dataset.cadence)
          : this.dataset.oneTimeSummary;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
